import React from 'react';
import { TimelineMax, Power1 } from "gsap";
import styled from 'styled-components';

class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.timeline = new TimelineMax({ paused: true });
  }

  componentDidMount() {
    this.timeline.from(this.footer, 1.2, {
      autoAlpha: 0,
      delay: 1,
      y: -15,
      ease: Power1.ease
    })

    this.timeline.play();
  }

  render() {
    return (
      <FooterStyled ref={footer => (this.footer = footer)}>
        <div className="container">
          <p>Copyright © {new Date().getFullYear()} Paralele. All Rights Reserved. Powered by <a href="https://www.creatiwwwa.me" target="_blank">Creatiwwwa</a></p>
        </div>
      </FooterStyled>
    )
  }
}

const FooterStyled = styled.footer`
  margin-top: 120px;
  margin-bottom: 50px;
  text-align: center;
`

export default Footer;